module.exports = __webpack_public_path__ + "static/media/kanton.352c9376.png";